import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.paymentReminder || initialState;

export const selectPendingOrderReport = createSelector(
  [selectDomain],
  (state) => state.pendingReport
);

export const selectRemindersInProgress = createSelector(
  [selectDomain],
  (state) => state.reminderInProgress
);

export const selectOrders = createSelector(
  [selectDomain],
  (state) => state.orders
);
